//#region Imports
import React, { useState, useEffect, useRef, useContext } from "react";
import {
  StyleSheet,
  Platform,
  SafeAreaView,
  FlatList,
  View,
  useWindowDimensions,
} from "react-native";
import { useTheme } from "@react-navigation/native";
import { createCommonStyles } from "../../../styles/commonStyles";
import CustomButton from "../../../components/CustomButton";
import CustomLabel from "../../../components/CustomLabel/CustomLabel";
import HRAdminBranchesScreen from "../HRAdminCompany/Branches_Locations/HRAdminBranchesScreen";
import CustomDropDownWithIcons from "../../../components/CustomDropDownWithIcons";
import CustomActivityIndicator from "../../../components/CustomActivityIndicator/CustomActivityIndicator";
import { useCompany } from "../../../hooks/useCompany";
import HRAdminDocumentsScreen from "../HRAdminCompany/Documents/HRAdminDocumentsScreen";
import HRAdminEditCompanyScreen from "../HRAdminCompany/HRAdminEditCompanyScreen";
import HRAdminSalarySchemeScreen from "../HRAdminCompany/Salary/HRAdminSalarySchemeScreen";
import HRAdminRatesScreen from "../HRAdminCompany/Rates/HRAdminRatesScreen";
import HRAdminFunctionsScreen from "../HRAdminCompany/Func_Serv_Dept/HRAdminFunctionsScreen";
import HRAdminEmplContextScreen from "../HRAdminCompany/HRAdminEmplContextScreen";
import HRAdminStaffLevelScreen from "../HRAdminCompany/HRAdminStaffLevelScreen";
import HRAdminJobTitleScreen from "../HRAdminCompany/HRAdminJobTitleScreen";
import HRAdminLeaveTypesScreen from "../HRAdminCompany/HRAdminLeaveTypesScreen";
import HRAdminLeaveSchemeScreen from "../HRAdminCompany/HRAdminLeaveSchemeScreen";
import HRAdminWorkflowsScreen from "../HRAdminCompany/Workflows/HRAdminWorkflowsScreen";
import HRAdminAuthorizationsScreen from "../HRAdminCompany/HRAdminAuthorizationsScreen";
import { HRAdminCompanyContext } from "../../../context/HRAdminCompanyContext";
import HRAdminMassUploadScreen from "../HRAdminCompany/HRAdminMassUpload";
import { useAccountContext } from "../../../hooks/useAccountContext";
import { useTranslation } from "react-i18next";
import { TASKS, TASK_OPTIONS } from "../../../constants/Tasks";
import RoleGuard from "../../../components/RoleGuard";
import useRole from "../../../hooks/userRole";
//#endregion

const HRAdminPageCompany = () => {
  //#region Const Definitions and UseRef and UseState
  const { t } = useTranslation();
  const { isAdmin } = useRole();
  const { width, height } = useWindowDimensions();
  //* For Branches Location show - Now in company parent in order to change the title accordingly
  const [showLocations, setShowLocations] = useState(false);
  const [showServiceLines, setShowServiceLines] = useState(false);
  const [showDepartments, setShowDepartments] = useState(false);
  const [userRoleTasks, setUserRoleTasks] = useState({});
  const [showSalaryScheme, setShowSalaryScheme] = useState(false);
  const [showSeniorityLevels, setShowSeniorityLevels] = useState(false);
  const [showNewCompanyScreen, setShowNewCompanyScreen] = useState(0);
  const showNewCompanyScreenRef = useRef(0);
  const [showEditCompanyScreen, setShowEditCompanyScreen] = useState(0);
  const showEditCompanyScreenRef = useRef(0);
  const [showBranchesScreen, setShowBranchesScreen] = useState(0);
  const showBranchesScreenRef = useRef(0);
  const [showFunctionsScreen, setShowFunctionScreen] = useState(0);
  const showFunctionsScreenRef = useRef(0);
  const [showEmplContextScreen, setShowEmplContextScreen] = useState(0);
  const showEmplContextScreenRef = useRef(0);
  const [showStaffLevelScreen, setShowStaffLevelScreen] = useState(0);
  const showStaffLevelScreenRef = useRef(0);
  const [showJobTitleScreen, setShowJobTitleScreen] = useState(0);
  const showJobTitleScreenRef = useRef(0);
  const [showLeaveTypesScreen, setShowLeaveTypesScreen] = useState(0);
  const showLeaveTypesScreenRef = useRef(0);
  const [showLeaveSchemeScreen, setShowLeaveSchemeScreen] = useState(0);
  const showLeaveSchemeScreenRef = useRef(0);
  const [showWorkflowsScreen, setShowWorkflowsScreen] = useState(0);
  const showWorkflowsScreenRef = useRef(0);
  const [showSalarySchemeScreen, setshowSalarySchemeScreen] = useState(0);
  const showSalarySchemeScreenRef = useRef(0);
  const [showRatesScreen, setshowRatesScreen] = useState(0);
  const showRatesScreenRef = useRef(0);
  const selectedCompanyCodeRef = useRef(0);
  const [showAuthScreen, setShowAuthScreen] = useState(0);
  const showAuthScreenRef = useRef(0);
  const [showCompanyDocuments, setShowCompanyDocuments] = useState(0);
  const showCompanyDocumentsRef = useRef(0);
  const [currencies, setCurrencies] = useState([]);
  const [showMassUploadScreen, setShowMassUploadScreen] = useState(0);
  const showMassUploadScreenRef = useRef(0);
  const { selectedCompany, setSelectedCompany, companyOptions, setCompanyOptions, setSelectedCompanyCode, selectedCompanyCode } = useContext(
    HRAdminCompanyContext
  );
  const [showCompany, setShowCompany] = useState(0);
  const { account } = useAccountContext();
  const buttonTable = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const { colors } = useTheme();
  const common = createCommonStyles(colors);
  const styles = makeStyles(colors);
  const { getCompanies, getCurrencies, isLoading } = useCompany();
  let selectedCompanyRef = useRef();
  const flatListRef = useRef(null);
  //#region SubMenu Listeners
  const resetScreens = () => {
    setShowBranchesScreen(0);
    setShowLocations(false);
    setShowEditCompanyScreen(0);
    setShowNewCompanyScreen(0);
    setShowCompanyDocuments(0);
    setShowFunctionScreen(0);
    setShowEmplContextScreen(0);
    setShowStaffLevelScreen(0);
    setShowJobTitleScreen(0);
    setShowLeaveTypesScreen(0);
    setShowLeaveSchemeScreen(0);
    setShowWorkflowsScreen(0);
    setshowSalarySchemeScreen(0);
    setshowRatesScreen(0);
    setShowAuthScreen(0);
    setShowMassUploadScreen(0);
  }
  const pressedOnNewCompany = (index) => {
    resetScreens()
    setShowNewCompanyScreen(1);
    setSelectedCompanyCode(undefined);
    setSelectedCompany({ code: undefined, description: undefined });
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnEditCompany = (index) => {
    resetScreens();
    setShowEditCompanyScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnBranches = (index) => {
    resetScreens();
    setShowBranchesScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnCompanyDocuments = (index) => {
    resetScreens();
    setShowCompanyDocuments(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnFunctions = (index) => {
    resetScreens()
    setShowFunctionScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnEmplContext = (index) => {
    resetScreens();
    setShowEmplContextScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnStaffLevel = (index) => {
    resetScreens();
    setShowStaffLevelScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnJobTitles = (index) => {
    resetScreens();
    setShowJobTitleScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnLeaveTypes = (index) => {
    resetScreens();
    setShowLeaveTypesScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnLeaveSchemes = (index) => {
    resetScreens();
    setShowLeaveSchemeScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnWorkflows = (index) => {
    resetScreens();
    setShowWorkflowsScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnAuth = (index) => {
    resetScreens();
    setShowAuthScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  const pressedOnRates = (index) => {
    resetScreens();
    setshowRatesScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };
  const pressedOnSalaryReview = (index) => {
    resetScreens();
    setshowSalarySchemeScreen(1);
    setShowMassUploadScreen(0);
    scrollToTab(index);
  };

  const pressedOnMassUpload = (index) => {
    resetScreens();
    setShowMassUploadScreen(1);
    makeInnerCalleeComponentsFalse();
    scrollToTab(index);
  };

  // When pressing on a different component and then back to the previous component, it should show you the starting page
  // and not the children. ** maybe its better to show the children but needs to save more info than just the screen **
  const makeInnerCalleeComponentsFalse = () => {
    setShowServiceLines(false);
    setShowDepartments(false);
  };

  const scrollToTab = (index) => {
    flatListRef.current?.scrollToIndex({
      index,
      animated: true,
      viewPosition: 0.5,
    });
  };
  //#endregion

  //#endregion

  //#region UseEffect

  useEffect(() => {
    if (companyOptions.length === 0) return;
    if (Platform.OS === "web") {
      checkIfRefreshed()
        .then(() => { })
        .catch(console.error);
    }
  }, [companyOptions]);

  useEffect(() => {
    makeInnerCalleeComponentsFalse();
    pressedOnEditCompany(0);
  }, [selectedCompanyCode]);

  useEffect(() => {
    if (companyOptions.length === 1)
      setSelectedCompanyCode(companyOptions[0]?.value)
  }, [companyOptions])

  useEffect(() => {
    getCompanies().then((companies) => {
      setCompanyOptions(companies);
      getCurrencies().then((curr) => {
        setCurrencies(curr);
      });
    });
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      try {
        localStorage.setItem(
          "showNewCompanyScreen",
          showNewCompanyScreenRef.current
        );
        localStorage.setItem(
          "showEditCompanyScreen",
          showEditCompanyScreenRef.current
        );
        localStorage.setItem(
          "showBranchesScreen",
          showBranchesScreenRef.current
        );
        localStorage.setItem(
          "showFunctionsScreen",
          showFunctionsScreenRef.current
        );
        localStorage.setItem(
          "showEmplContextScreen",
          showEmplContextScreenRef.current
        );
        localStorage.setItem(
          "showStaffLevelScreen",
          showStaffLevelScreenRef.current
        );
        localStorage.setItem(
          "showJobTitleScreen",
          showJobTitleScreenRef.current
        );
        localStorage.setItem(
          "showLeaveTypesScreen",
          showLeaveTypesScreenRef.current
        );
        localStorage.setItem(
          "showLeaveSchemeScreen",
          showLeaveSchemeScreenRef.current
        );
        localStorage.setItem(
          "showWorkflowsScreen",
          showWorkflowsScreenRef.current
        );
        localStorage.setItem(
          "showSalarySchemeScreen",
          showSalarySchemeScreenRef.current
        );
        localStorage.setItem(
          "showRatesScreen",
          showRatesScreenRef.current
        );
        localStorage.setItem("showAuthScreen", showAuthScreenRef.current);
        localStorage.setItem(
          "showCompanyDocuments",
          showCompanyDocumentsRef.current
        );
        localStorage.setItem(
          "showMassUploadScreen",
          showMassUploadScreenRef.current
        );
        localStorage.setItem(
          "selectedCompany",
          selectedCompanyCodeRef.current
        );
        localStorage.setItem(
          "selectedCompanyContext",
          JSON.stringify(selectedCompany)
        );
        localStorage.setItem("isRefresh", "true");
        localStorage.setItem("lastVisitedScreen", "HRAdminPageCompany");
      } catch (error) {
        console.log(error.message);
      }
    };
    if (Platform.OS === "web") {
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [account]);

  //* if refreshed, get data from session storage,
  //* to show same page as before refresh
  const checkIfRefreshed = async () => {
    try {
      let isRefresh = localStorage.getItem("isRefresh");
      if (isRefresh === "true") {
        setSelectedCompanyCode(localStorage.getItem("selectedCompany"));
        setShowNewCompanyScreen(
          parseInt(localStorage.getItem("showNewCompanyScreen"))
        );
        setShowEditCompanyScreen(
          parseInt(localStorage.getItem("showEditCompanyScreen"))
        );
        setShowBranchesScreen(
          parseInt(localStorage.getItem("showBranchesScreen"))
        );
        setShowFunctionScreen(
          parseInt(localStorage.getItem("showFunctionsScreen"))
        );
        setShowEmplContextScreen(
          parseInt(localStorage.getItem("showEmplContextScreen"))
        );
        setShowStaffLevelScreen(
          parseInt(localStorage.getItem("showStaffLevelScreen"))
        );
        setShowJobTitleScreen(
          parseInt(localStorage.getItem("showJobTitleScreen"))
        );
        setShowLeaveTypesScreen(
          parseInt(localStorage.getItem("showLeaveTypesScreen"))
        );
        setShowLeaveSchemeScreen(
          parseInt(localStorage.getItem("showLeaveSchemeScreen"))
        );
        setShowWorkflowsScreen(
          parseInt(localStorage.getItem("showWorkflowsScreen"))
        );
        setshowSalarySchemeScreen(
          parseInt(localStorage.getItem("showSalarySchemeScreen"))
        );
        setshowRatesScreen(
          parseInt(localStorage.getItem("showRatesScreen"))
        );
        setShowCompanyDocuments(
          parseInt(localStorage.getItem("showCompanyDocuments"))
        );
        setShowAuthScreen(parseInt(localStorage.getItem("showAuthScreen")));
        setShowMassUploadScreen(
          parseInt(localStorage.getItem("showMassUploadScreen"))
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  // * On select actual company then show edit company.
  useEffect(() => {
    if (selectedCompanyCode !== undefined) {
      selectedCompanyCodeRef.current = selectedCompanyCode;
      const selectedOption = companyOptions.find(
        (option) => option.value === selectedCompanyCode
      );
      if (selectedOption !== undefined)
        setSelectedCompany({
          code: selectedOption.value,
          description: selectedOption.label,
        });
    }
  }, [selectedCompanyCode]);

  useEffect(() => { }, [width, height]);

  //#region Assign UseRef
  useEffect(() => {
    showNewCompanyScreenRef.current = showNewCompanyScreen;
  }, [showNewCompanyScreen]);
  useEffect(() => {
    showEditCompanyScreenRef.current = showEditCompanyScreen;
  }, [showEditCompanyScreen]);
  useEffect(() => {
    showBranchesScreenRef.current = showBranchesScreen;
  }, [showBranchesScreen]);
  useEffect(() => {
    showFunctionsScreenRef.current = showFunctionsScreen;
  }, [showFunctionsScreen]);
  useEffect(() => {
    showEmplContextScreenRef.current = showEmplContextScreen;
  }, [showEmplContextScreen]);
  useEffect(() => {
    showStaffLevelScreenRef.current;
  }, [showStaffLevelScreen]);
  useEffect(() => {
    showJobTitleScreenRef.current = showJobTitleScreen;
  }, [showJobTitleScreen]);
  useEffect(() => {
    showLeaveTypesScreenRef.current = showLeaveTypesScreen;
  }, [showLeaveTypesScreen]);
  useEffect(() => {
    showLeaveSchemeScreenRef.current = showLeaveSchemeScreen;
  }, [showLeaveSchemeScreen]);
  useEffect(() => {
    showWorkflowsScreenRef.current = showWorkflowsScreen;
  }, [showWorkflowsScreen]);
  useEffect(() => {
    showSalarySchemeScreenRef.current = showSalarySchemeScreen;
  }, [showSalarySchemeScreen]);
  useEffect(() => {
    showRatesScreenRef.current = showRatesScreen;
  }, [showRatesScreen]);
  useEffect(() => {
    showAuthScreenRef.current = showAuthScreen;
  }, [showAuthScreen]);
  useEffect(() => {
    showCompanyDocumentsRef.current = showCompanyDocuments;
  }, [showCompanyDocuments]);
  useEffect(() => {
    showMassUploadScreenRef.current = showMassUploadScreen;
  }, [showMassUploadScreen]);
  //#endregion

  //#region Helpers
  //#endregion

  //#endregion

  if (isLoading) {
    return (
      <CustomActivityIndicator />
    );
  }

  return (
    <SafeAreaView style={styles.main}>
      {/* //* first row tabs */}
      <View style={styles.mainSubTabs}>
        <View style={styles.mainSubTabsDropdown}>
          <CustomDropDownWithIcons
            defValue={selectedCompanyCode}
            options={companyOptions}
            setValue={setSelectedCompanyCode}
            type="MYPROFILE"
          />
        </View>
        <CustomButton
          onPress={() => {
            pressedOnNewCompany();
          }}
          text={t("navigate:newCompany")}
          iconName="business-outline"
          show={showNewCompanyScreen ? "HOME_SELECTED" : "HOME"}
          type={showNewCompanyScreen ? "HOME_SELECTED" : "HOME"}
          textTop="0"
          sz={Platform.OS !== "web" ? 20 : 25}
          isGradient={showNewCompanyScreen ? true : false}
        />
      </View>
      <View style={common.divider} />
      {/* //*  second row tabs */}
      {selectedCompanyCode && (
        <View>
          <FlatList
            ref={flatListRef}
            onScrollToIndexFailed={(info) => {
              flatListRef.current?.scrollToOffset({
                offset: info.averageItemLength * info.index,
                animated: true,
              });
            }}
            horizontal
            showsHorizontalScrollIndicator={true}
            directionalLockEnabled={true}
            alwaysBounceVertical={false}
            data={buttonTable}
            contentContainerStyle={{
              alignSelf: "flex-start",
              marginBottom: "1%",
            }}
            showsVerticalScrollIndicator={true} //shows horizontal scroll bar on web
            renderItem={({ index }) => {
              return (
                <SafeAreaView>
                  {index == 0 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.EDITCOMPANY} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showEditCompanyScreen) return;
                          pressedOnEditCompany(0);
                        }}
                        text={t("navigate:editCompany")}
                        iconName="business-outline"
                        show={showEditCompanyScreen ? "HOME_SELECTED" : "HOME"}
                        type={showEditCompanyScreen ? "HOME_SELECTED" : "HOME"}
                        textTop="0"
                        isGradient={showEditCompanyScreen ? true : false}
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}
                  {index == 1 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.BRANCHES} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showBranchesScreen) return;
                          pressedOnBranches(1);
                        }}
                        text={t("navigate:branches")}
                        iconName="git-branch-outline"
                        show={showBranchesScreen ? "HOME_SELECTED" : "HOME"}
                        type={showBranchesScreen ? "HOME_SELECTED" : "HOME"}
                        textTop="0"
                        isGradient={showBranchesScreen ? true : false}
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}
                  {index == 2 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.ATTACHDOC} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showCompanyDocuments) return;
                          pressedOnCompanyDocuments(2);
                        }}
                        text={t("navigate:documents")}
                        iconName="documents-outline"
                        show={showCompanyDocuments ? "HOME_SELECTED" : "HOME"}
                        type={showCompanyDocuments ? "HOME_SELECTED" : "HOME"}
                        isGradient={showCompanyDocuments ? true : false}
                        textTop="0"
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}
                  {index == 3 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.FUNCTIONS} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showFunctionsScreen) return;
                          pressedOnFunctions(3);
                        }}
                        text={t("navigate:functionsServiceLinesDepts")}
                        iconName="newspaper-outline"
                        show={showFunctionsScreen ? "HOME_SELECTED" : "HOME"}
                        type={showFunctionsScreen ? "HOME_SELECTED" : "HOME"}
                        isGradient={showFunctionsScreen ? true : false}
                        textTop="0"
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}
                  {index == 4 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.EMPLCONTEXT} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showEmplContextScreen) return;
                          pressedOnEmplContext(4);
                        }}
                        text={t("navigate:emplContext")}
                        iconName="cube-outline"
                        show={showEmplContextScreen ? "HOME_SELECTED" : "HOME"}
                        type={showEmplContextScreen ? "HOME_SELECTED" : "HOME"}
                        isGradient={showEmplContextScreen ? true : false}
                        textTop="0"
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}
                  {index == 5 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.EMPLCONTEXT} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showStaffLevelScreen) return;
                          pressedOnStaffLevel(5);
                        }}
                        text={t("navigate:staffLevelSeniorityLevel")}
                        iconName="clipboard-outline"
                        show={showStaffLevelScreen ? "HOME_SELECTED" : "HOME"}
                        type={showStaffLevelScreen ? "HOME_SELECTED" : "HOME"}
                        isGradient={showStaffLevelScreen ? true : false}
                        textTop="0"
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}

                  {index == 6 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.JOBTITLES} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showJobTitleScreen) return;
                          pressedOnJobTitles(6);
                        }}
                        text={t("navigate:jobTitles")}
                        iconName="briefcase-outline"
                        show={showJobTitleScreen ? "HOME_SELECTED" : "HOME"}
                        type={showJobTitleScreen ? "HOME_SELECTED" : "HOME"}
                        isGradient={showJobTitleScreen ? true : false}
                        textTop="0"
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}

                  {index == 7 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.LEAVETYPES} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showLeaveTypesScreen) return;
                          pressedOnLeaveTypes(7);
                        }}
                        text={t("navigate:leaveTypes")}
                        iconName="calendar-outline"
                        show={showLeaveTypesScreen ? "HOME_SELECTED" : "HOME"}
                        type={showLeaveTypesScreen ? "HOME_SELECTED" : "HOME"}
                        isGradient={showLeaveTypesScreen ? true : false}
                        textTop="0"
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}
                  {index == 8 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.LEAVESCHEMES} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showLeaveSchemeScreen) return;
                          pressedOnLeaveSchemes(8);
                        }}
                        text={t("navigate:leaveSchemes")}
                        iconName="trail-sign-outline"
                        show={showLeaveSchemeScreen ? "HOME_SELECTED" : "HOME"}
                        type={showLeaveSchemeScreen ? "HOME_SELECTED" : "HOME"}
                        isGradient={showLeaveSchemeScreen ? true : false}
                        textTop="0"
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}
                  {index == 9 && (
                    <CustomButton
                      onPress={() => {
                        if (showWorkflowsScreen) return;
                        pressedOnWorkflows(9);
                      }}
                      text={t("navigate:workflows")}
                      iconName="git-network-outline"
                      show={showWorkflowsScreen ? "HOME_SELECTED" : "HOME"}
                      type={showWorkflowsScreen ? "HOME_SELECTED" : "HOME"}
                      isGradient={showWorkflowsScreen ? true : false}
                      textTop="0"
                      sz={Platform.OS !== "web" ? 20 : 25}
                    />
                  )}
                  {index == 10 && (
                    <CustomButton
                      onPress={() => {
                        if (showAuthScreen) return;
                        pressedOnAuth(10);
                      }}
                      text={t("navigate:authorizations")}
                      iconName="lock-open-outline"
                      show={showAuthScreen ? "HOME_SELECTED" : "HOME"}
                      type={showAuthScreen ? "HOME_SELECTED" : "HOME"}
                      isGradient={showAuthScreen ? true : false}
                      textTop="0"
                      sz={Platform.OS !== "web" ? 20 : 25}
                    />
                  )}
                  {index == 11 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.STDRATES} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showRatesScreen) return;
                          pressedOnRates(11);
                        }}
                        text={t("navigate:rates")}
                        iconName="pricetag-outline"
                        show={showRatesScreen ? "HOME_SELECTED" : "HOME"}
                        type={showRatesScreen ? "HOME_SELECTED" : "HOME"}
                        isGradient={showRatesScreen ? true : false}
                        textTop="0"
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}
                  {index == 12 && (
                    <RoleGuard parentTask={TASKS.COMPANY} task={TASK_OPTIONS.SALARYSCHEME} table='hr' requireCRUD>
                      <CustomButton
                        onPress={() => {
                          if (showSalaryScheme) return;
                          pressedOnSalaryReview(12);
                        }}
                        text={t("navigate:salarySchemes")}
                        iconName="cash-outline"
                        show={showSalarySchemeScreen ? "HOME_SELECTED" : "HOME"}
                        type={showSalarySchemeScreen ? "HOME_SELECTED" : "HOME"}
                        isGradient={showSalarySchemeScreen ? true : false}
                        textTop="0"
                        sz={Platform.OS !== "web" ? 20 : 25}
                      />
                    </RoleGuard>
                  )}
                  {index == 13 && (
                    <CustomButton
                      onPress={() => {
                        if (showMassUploadScreen) return;
                        pressedOnMassUpload(13);
                      }}
                      text={t("navigate:massUpload")}
                      iconName="cloud-upload-outline"
                      show={showMassUploadScreen ? "HOME_SELECTED" : "HOME"}
                      type={showMassUploadScreen ? "HOME_SELECTED" : "HOME"}
                      isGradient={showMassUploadScreen ? true : false}
                      textTop="0"
                      sz={Platform.OS !== "web" ? 20 : 25}
                    />
                  )}
                </SafeAreaView>
              );
            }}
            keyExtractor={(item) => `${item}`}
          />
        </View>
      )
      }

      {/* Views to show depending on Flatlist Selection */}
      {showEditCompanyScreen || showNewCompanyScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel
            value={
              showEditCompanyScreen
                ? t("navigate:editCompany")
                : t("navigate:newCompany")
            }
            type="MINORTITLE"
          />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminEditCompanyScreen
              selectedCompany={selectedCompanyCode}
              showNewCompanyScreen={showNewCompanyScreen}
            />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showBranchesScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel
            value={
              showLocations
                ? t("navigate:branches") + "  |  " + t("common:locations")
                : t("navigate:branches")
            }
            type="MINORTITLE"
          />
          <SafeAreaView style={[styles.additionalCard]}>

            <HRAdminBranchesScreen
              selectedCompany={selectedCompanyCode}
              showLocations={showLocations}
              setShowLocations={setShowLocations}
            />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showCompanyDocuments ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel value={t("navigate:documents")} type="MINORTITLE" />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminDocumentsScreen selectedCompany={selectedCompanyCode} />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showFunctionsScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel
            value={
              showDepartments
                ? t("navigate:functions") +
                "  |  " +
                t("common:serviceLines") +
                "  |  " +
                t("common:departments")
                : showServiceLines
                  ? t("navigate:functions") + "  |  " + t("common:serviceLines")
                  : t("navigate:functions")
            }
            type="MINORTITLE"
          />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminFunctionsScreen
              selectedCompany={selectedCompanyCode}
              showServiceLines={showServiceLines}
              setShowServiceLines={setShowServiceLines}
              showDepartments={showDepartments}
              setShowDepartments={setShowDepartments}
            />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showEmplContextScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel value={t("navigate:emplContext")} type="MINORTITLE" />
          <SafeAreaView style={[styles.additionalCard]}>
            {<HRAdminEmplContextScreen selectedCompany={selectedCompanyCode} />}
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showStaffLevelScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel
            value={
              showSeniorityLevels
                ? t("navigate:staffLevel") + "  |  " + t("navigate:seniorityLevels")
                : t("navigate:staffLevel")
            }
            type="MINORTITLE"
          />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminStaffLevelScreen
              selectedCompany={selectedCompanyCode}
              showSeniorityLevels={showSeniorityLevels}
              setShowSeniorityLevels={setShowSeniorityLevels}
            />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}


      {showJobTitleScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel value={t("navigate:jobTitles")} type="MINORTITLE" />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminJobTitleScreen
              selectedCompany={selectedCompanyCode}
            />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showLeaveTypesScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel value={t("navigate:leaveTypes")} type="MINORTITLE" />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminLeaveTypesScreen
              selectedCompany={selectedCompanyCode}
            />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showLeaveSchemeScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel value={t("navigate:leaveSchemes")} type="MINORTITLE" />
          <SafeAreaView style={[styles.additionalCard]}>
            {<HRAdminLeaveSchemeScreen
              selectedCompany={selectedCompanyCode}
            />}
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showWorkflowsScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel value={t("navigate:workflows")} type="MINORTITLE" />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminWorkflowsScreen
              selectedCompany={selectedCompanyCode}
            />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showAuthScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel value={t("navigate:authorizations")} type="MINORTITLE" />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminAuthorizationsScreen
              selectedCompany={selectedCompanyCode}
            />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showRatesScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel value={t("navigate:rates")} type="MINORTITLE" />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminRatesScreen
              selectedCompany={selectedCompanyCode}
            />
            {/** TODO: DO SCREEN */}
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}
      {showSalarySchemeScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel value={t("navigate:salarySchemes")} type="MINORTITLE" />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminSalarySchemeScreen
              selectedCompany={selectedCompanyCode}
              showSalaryScheme={showSalaryScheme}
              setShowSalaryScheme={setShowSalaryScheme}
              currencies={currencies}
            />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showMassUploadScreen ? (
        <SafeAreaView style={styles.main}>
          <CustomLabel value={t("navigate:massUpload")} type="MINORTITLE" />
          <SafeAreaView style={[styles.additionalCard]}>
            <HRAdminMassUploadScreen selectedCompany={selectedCompanyCode} />
          </SafeAreaView>
        </SafeAreaView>
      ) : (
        <></>
      )}
    </SafeAreaView>
  );
};

const makeStyles = (colors) =>
  StyleSheet.create({
    main: {
      flex: 1,
    },
    mainSubTabs: {
      zIndex: 2000,
      flexDirection: "row",
      alignSelf: "flex-start",
      marginTop: 5,
    },
    mainSubTabsDropdown: {
      width: "100%",
      maxWidth: 400,
      justifyContent: "center",
      marginHorizontal: 10,
    },
    additionalCard: {
      flex: 1,
      marginVertical: 10,
      marginHorizontal: 30,
    },
  });

export default HRAdminPageCompany;
